// import { cn } from "../../utils/cn";
// import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";

// interface TableData {
//   id: number;
//   name: string;
//   price: string;
//   status: string;
//   date: string;
//   // expiration_date: string;
// }

// export interface AnimatedTableProps {
//   data: TableData[];
//   columns: Column[];
//   checkbox?: boolean;
//   initialPage?: number;
//   initialPageSize?: number;
//   className?: string;
//   view?: boolean;
// }

// const DashboardSubscriptionTable = () => {
//   const tableData: TableData[] = [
//     {
//       id: 53767,
//       name: "Dom Enterprise",
//       price: "₦150,000",
//       status: "Active",
//       date: "March 15, 2025",
//       // expiration_date: "March 15, 2025",
//     },
//     {
//       id: 53768,
//       name: "Peniel Travels",
//       price: "₦100,000",
//       status: "Inactive",
//       date: "August 12, 2025",
//       // expiration_date: "March 15, 2025",
//     },
//     {
//       id: 53769,
//       name: "Charly & Sons",
//       price: "₦100,000",

//       status: "Active",
//       date: "March 15, 2025",
//       // expiration_date: "March 15, 2025",
//     },
//     {
//       id: 53770,
//       name: "Peniel Travels",
//       price: "₦100,000",

//       status: "Inactive",
//       date: "March 15, 2025",
//       // expiration_date: "March 15, 2025",
//     },
//     {
//       id: 53771,
//       name: "Dom",
//       price: "₦100,000",

//       status: "Active",
//       date: "March 15, 2025",
//       // expiration_date: "March 15, 2025",
//     },
//     {
//       id: 53772,
//       name: "Charles Angels",
//       price: "₦150,000",

//       status: "Inactive",
//       date: "March 15, 2025",
//       // expiration_date: "March 15, 2025",
//     },
//     {
//       id: 53773,
//       name: "Odogwu Paranran",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 15, 2025",
//     },
//     {
//       id: 53774,
//       name: "NSPPD Movements",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 09, 2025",
//     },
//     {
//       id: 53775,
//       name: "Peniel Travels",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 15, 2025",
//     },
//     {
//       id: 53776,
//       name: "Chisco Logistics",
//       price: "₦150,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 15, 2025",
//     },
//     {
//       id: 53777,
//       name: "ABC Transport",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 16, 2025",
//     },
//     {
//       id: 53778,
//       name: "XYZ Shipping",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "August 10, 2025",
//     },
//     {
//       id: 53779,
//       name: "123 Traders",
//       price: "₦150,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 18, 2025",
//     },
//     {
//       id: 53780,
//       name: "Quick Movers",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 20, 2025",
//     },
//     {
//       id: 53781,
//       name: "Best Logistics",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 22, 2025",
//     },
//     {
//       id: 53782,
//       name: "Reliable Services",
//       price: "₦150,000",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 24, 2025",
//     },
//     {
//       id: 53783,
//       name: "Top Haulers",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 26, 2025",
//     },
//     {
//       id: 53784,
//       name: "Swift Deliveries",
//       price: "₦50,000 ",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 28, 2025",
//     },
//     {
//       id: 53785,
//       name: "Prime Transport",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 30, 2025",
//     },
//     {
//       id: 53786,
//       name: "Global Shipping",
//       price: "₦150,000  ",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "April 01, 2025",
//     },
//     {
//       id: 53787,
//       name: "Swift Deliveries",
//       price: "₦50,000 ",
//       // expiration_date: "March 15, 2025",
//       status: "Inactive",
//       date: "March 28, 2025",
//     },
//     {
//       id: 53788,
//       name: "Prime Transport",
//       price: "₦100,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "March 30, 2025",
//     },
//     {
//       id: 53789,
//       name: "Global Shipping",
//       price: "₦150,000",
//       // expiration_date: "March 15, 2025",
//       status: "Active",
//       date: "April 01, 2025",
//     },
//   ];

//   const columns: Column[] = [
//     { label: "#OrderID", key: "id", sortable: true },
//     { label: "Order Type", key: "name", sortable: true },
//     { label: "Price", key: "price", sortable: true },
//     {
//       label: "Status",
//       key: "status",
//       render: (value) => (
//         <span
//           className={cn(
//             "px-2 py-1 rounded",
//             value === "Active"
//               ? "bg-green-100 text-green-800"
//               : "bg-red-100 text-red-800"
//           )}
//         >
//           {value}
//         </span>
//       ),
//     },

//     { label: "Date", key: "date", sortable: true },
//     // { label: "Expiration date", key: "expiration_date", sortable: true },
//   ];

//   return (
//     <div>
//       <FleetrifyCustomTable
//         tableClassName="!rounded-none"
//         data={tableData}
//         columns={columns}
//         checkbox={false}
//       />
//     </div>
//   );
// };

// export default DashboardSubscriptionTable;



import { cn } from "../../utils/cn";
import { Column, FleetrifyCustomTable } from "../CustomTable/customTable";
import { RecentOrder } from "../../redux/services/clienDashboardApi";

interface Props {
  orders: RecentOrder[];
  isLoading?: boolean;
}

const orderTypeLabels: Record<string, string> = {
  local_relocation: "Local Relocation",
  local_dispatch: "Day to Day Delivery",
  interstate_relocation: "Interstate Relocation",
  interstate_dispatch: "Interstate Dispatch",
};

const formatOrderType = (type: string): string => {
  return (
    orderTypeLabels[type] ??
    type
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ")
  );
};

const statusStyles: Record<string, string> = {
  pending:   "bg-yellow-100 text-yellow-800",
  delivered: "bg-green-100 text-green-800",
  completed: "bg-green-100 text-green-800",
  cancelled: "bg-red-100 text-red-800",
  failed:    "bg-red-100 text-red-800",
};

const formatStatus = (status: string): string => {
  return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
};

const DashboardSubscriptionTable = ({ orders, isLoading }: Props) => {
  const tableData = orders.map((order) => ({
    id: order.order_id,
    name: formatOrderType(order.order_type),
    price: `₦${Number(order.price).toLocaleString()}`,
    status: order.status,
    date: order.created_at,
  }));

  const columns: Column[] = [
    { label: "#OrderID", key: "id", sortable: true },
    { label: "Order Type", key: "name", sortable: true },
    { label: "Price", key: "price", sortable: true },
    {
      label: "Status",
      key: "status",
      render: (value) => (
        <span
          className={cn(
            "px-2 py-1 rounded text-xs font-semibold",
            statusStyles[value.toLowerCase()] ?? "bg-gray-100 text-gray-800"
          )}
        >
          {formatStatus(value)}
        </span>
      ),
    },
    { label: "Date", key: "date", sortable: true },
  ];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-40 text-sm text-gray-400">
        Loading orders...
      </div>
    );
  }

  if (!orders.length) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 py-20">
        <div className="text-5xl text-gray-300">📄</div>
        <p className="text-base font-medium text-gray-600">No recent orders found.</p>
      </div>
    );
  }

  return (
    <div>
      <FleetrifyCustomTable
        tableClassName="!rounded-none"
        data={tableData}
        columns={columns}
        checkbox={false}
      />
    </div>
  );
};

export default DashboardSubscriptionTable;